/** 仅识别整篇由一个明确标注 Markdown 的闭合代码围栏包裹的内容。 */
export function unwrapMarkdownFence(markdown: string): string | null {
  const lines = /([^\r\n]*)(?:\r\n|\r|\n|$)/g
  let fence = ''
  let contentStart = 0
  let line: RegExpExecArray | null

  while ((line = lines.exec(markdown))) {
    // 文末的空匹配不会推进正则游标，直接结束以避免无限循环。
    if (!line[0].length) break

    if (!fence) {
      if (!line[1].trim()) continue

      const opening = /^ {0,3}(`{3,}|~{3,})[ \t]*(?:markdown|md)[ \t]*$/i.exec(
        line[1],
      )
      if (!opening) return null

      fence = opening[1]
      contentStart = line.index + line[0].length
      continue
    }

    const closing = /^ {0,3}(`{3,}|~{3,})[ \t]*$/.exec(line[1])
    if (
      !closing ||
      closing[1][0] !== fence[0] ||
      closing[1].length < fence.length
    ) {
      continue
    }

    // 第一个有效闭合围栏之后仍有正文，说明不是单个完整的外层代码块。
    if (markdown.slice(line.index + line[0].length).trim()) return null

    // 只移除围栏所需的换行，保留内部空行、缩进和原始换行格式。
    const content = markdown
      .slice(contentStart, line.index)
      .replace(/(?:\r\n|\r|\n)$/, '')
    return content.trim() ? content : null
  }

  return null
}
